<template>
  <div>
    <button type="button" @click="() => handleTypeChange(true)"
            class="flex items-center text-sm gap-1.5 mt-4 hover:underline font-medium"
            :style="textPrimary">
      <ArrowsRightLeftIcon class="h-4 w-4"/>
      <span>Give a {{alternateResponseType}} response instead</span>
    </button>

    <ModalConfirm v-model:open="showConfirmChangeType"
                  :title="`Switch to a ${alternateResponseType} answer?`"
                  level="danger"
                  description="Your existing answer will be erased."
                  cancel-button-text="Nevermind"
                  proceed-button-text="Change Answer Type"
                  @confirm="() => handleTypeChange(false)"/>
  </div>
</template>

<script setup>
import {ArrowsRightLeftIcon} from "@heroicons/vue/24/outline";
import {computed, inject, ref} from "vue";
import {darkestHex} from "../helpers/Color";
import ModalConfirm from "./ModalConfirm.vue";

const emits = defineEmits(["update:modelValue"]);
const props = defineProps({
  modelValue: String,
  initialType: String,
  answer: Object,
});

const showConfirmChangeType = ref(false);

const typeformData = inject("typeformData", {});
const darkestHexValue = computed(() => darkestHex(typeformData.primaryBackground, typeformData.primaryForeground));
const textPrimary = computed(() => `color:${darkestHexValue.value};`);

const options = props.initialType.split("_or_");
const alternateResponseType = computed(() => props.modelValue === options[0] ? options[1] : options[0]);

const handleTypeChange = (shouldConfirm) => {
  if (shouldConfirm) {
    showConfirmChangeType.value = true;
    return;
  }

  emits("update:modelValue", alternateResponseType.value);
};
</script>
